export const WHATSAPP_PRIMARY_COLOR = "#075E54";
export const MESSENGER_PRIMARY_COLOR = "#006AFF";
export const SMS_PRIMARY_COLOR = "#218aff";
export const SMS_SECONDARY_COLOR = "#218AFF";
export const VARIABLE_REGEX = /\{{([^)]+)\}}/gm;

